import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";
import { mapFrom } from "@warrenio/utils/collections/maps";
import { atomFamily } from "jotai-family";

type Response = Map<BillingAccountInvoice["id"], BillingAccountInvoice>;

export interface Params {
    billing_account_id: number;
}

export function getQueryKey(params?: Params): QueryKey {
    return params == null ? ["invoice/list"] : ["invoice/list", params.billing_account_id];
}

function getQuery(client: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<Response> => {
            const { billing_account_id } = params;
            return mapFrom(
                getResponseData(
                    await client.GET("/payment/invoice/list", {
                        signal,
                        params: { query: { billing_account_id } },
                    }),
                ),
                (invoice) => invoice.id,
            );
        },
    });
}

export const baInvoiceQueryAtom = atomFamily((billing_account_id: number) =>
    atomFromStandardQueryOptions(getQuery, { billing_account_id }),
);
